module.exports = __webpack_public_path__ + "img/varoszoba_ambrotipia.8becc61d.jpg";